import { cn } from '@/lib/utils'

interface LandingButtonProps {
    children: React.ReactNode
    variant?: 'blue' | 'white' | 'light-blue'
    className?: string
    onClick?: () => void
    disabled?: boolean
    type?: 'button' | 'submit' | 'reset'
}

export function LandingButton({
    children,
    variant = 'blue',
    className,
    onClick,
    disabled,
    type = 'button',
}: LandingButtonProps) {
    const baseClasses =
        'h-7.25 w-24.25 rounded-[1rem] flex items-center justify-center shadow-[0_3px_8px_0_rgba(0,0,0,0.08)]'

    const variantClasses = {
        blue: 'btn-gradient-blue',
        white: 'bg-white',
        'light-blue': 'bg-[rgba(10,132,255,0.2)]',
    }

    const textClasses = {
        blue: 'text-white',
        white: 'text-black',
        'light-blue': 'text-[rgba(10,132,255,1)]',
    }

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={cn(baseClasses, variantClasses[variant], className)}
        >
            <span className={cn('text-xs font-medium', textClasses[variant])}>{children}</span>
        </button>
    )
}
